import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";

import p1 from "../assets/partner1.svg";
import p2 from "../assets/partner2.svg";
import p3 from "../assets/partner3.svg";
import p4 from "../assets/partner4.svg";
import p5 from "../assets/partner5.svg";
import p6 from "../assets/partner6.svg";
import p7 from "../assets/partner7.svg";
import { useTranslation } from "react-i18next";

const partners = [p1, p2, p3, p4, p5, p6, p7];

const Partners = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto px-6 pt-20 pb-12 md:px-20">
      <div className="flex flex-col-reverse items-center justify-center gap-2">
        <div className="w-4 h-[1px] bg-dark"></div>
        <p className="text-dark/50 text-xs md:text-base">{t("partners")}</p>
      </div>
      <h2 className="text-center text-2xl mb-8 md:text-3xl font-bold md:mb-10">
        {t("partners")}
      </h2>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          0: { slidesPerView: 2 },
          640: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 5 },
        }}
      >
        {partners.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="flex items-center justify-center h-24 md:h-28">
              <img
                src={img}
                alt={`partner-${index}`}
                className="max-h-full object-contain transition-all duration-500"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Partners;
